module.exports = __webpack_public_path__ + "media/empty-states/kiosk-mode-2x-6a543fdf.png";